import { Outlet, Navigate } from "react-router-dom";
import { useStore } from "@/store/useStore";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";

export function AuthLayout() {
  const user = useStore((s) => s.user);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
